import { BLOB_IMAGE } from "../../constants/imageConstants";
import { MoveRight } from "lucide-react";

interface ServiceCardProps {
  title: string;
  description: string;
  color: string;
}

export default function ServiceCard({ title, description }: ServiceCardProps) {
  return (
    <div
      className={`bg-[#393054] rounded-2xl p-8 text-white min-h-[400px] flex flex-col justify-between relative overflow-hidden transform hover:scale-105 transition-transform duration-300`}
    >
      <div>
        <h3 className="text-2xl font-bold mb-4">{title}</h3>
        <p className="text-white w-1/2 leading-relaxed">{description}</p>
      </div>
      <img
        className="absolute bottom-0 right-0 size-96"
        src={BLOB_IMAGE}
        alt=""
      />

      <div className="mt-6 relative z-10">
        <button className="text-white flex items-center justify-start gap-2 border bg-[#393054] bg-opacity-55 border-white w-10/12 py-2 px-4 rounded-full transition-colors duration-200 font-medium">
          <span>Learn More</span>
          <MoveRight className="size-6" />
        </button>
      </div>
    </div>
  );
}
